module.exports = __webpack_public_path__ + "static/media/inbox-in.87cc318b.svg";